import { render, staticRenderFns } from "./InputValue.vue?vue&type=template&id=3d6c2b05"
import script from "./InputValue.vue?vue&type=script&lang=js"
export * from "./InputValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports